// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MyPhoneBook: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 38">
            <g fill="none" fillRule="evenodd">
                <path
                    fill="#A32638"
                    fillRule="nonzero"
                    d="M0 0h33.3C35.343 0 37 1.701 37 3.8v30.4c0 2.099-1.657 3.8-3.7 3.8H0V0Z"
                />
                <g stroke="#FFF">
                    <path d="M19.818 13.958c0 3.291-2.557 5.959-5.712 5.959s-5.712-2.668-5.712-5.959C8.394 10.668 10.95 8 14.106 8s5.712 2.667 5.712 5.958Z" />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 30c0-5.569 4.328-10.083 9.666-10.083 5.34 0 9.667 4.514 9.667 10.083H4Z"
                    />
                    <path d="M30.364 17.625c0 2.278-1.77 4.125-3.955 4.125-2.184 0-3.954-1.847-3.954-4.125s1.77-4.125 3.954-4.125 3.955 1.847 3.955 4.125Z" />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21.576 23.59a6.86 6.86 0 0 1 4.708-1.84c3.709 0 6.716 2.873 6.716 6.417h-9.253"
                    />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(MyPhoneBook);
